import Connecting from "../../../assets/images/connecting.jpg";
import Developing from "../../../assets/images/developing.jpg";
import Transforming from "../../../assets/images/transforming.jpg";
import Information from "../../../assets/images/information31.jpg";
import Admin from "../../../assets/images/admin2.jpg";
import Collections from "../../../assets/images/collections2.jpg";
import Corporate from "../../../assets/images/corporate2.jpg";
import Business from "../../../assets/images/ebusiness2.jpg";
import Finance from "../../../assets/images/finance2.jpg";
import Foreign from "../../../assets/images/foreign-exchange2.jpg";
import Holidays from "../../../assets/images/holidays2.jpg";
import HumanResource from "../../../assets/images/hr2.jpg";
import Mice from "../../../assets/images/mice2.jpg";
import Secretarial from "../../../assets/images/secretarial2.jpg";
import Shared from "../../../assets/images/shared2.jpg";

const connectWithList = [
  {
    title: "Connecting..",
    imageUrl: Connecting,
    description:
      "When people with multi-cultural background connect there is a confluence of ideas that inevitably leads to greater engagement. At Thomas Cook India Group we believe in engaging and connecting with our employees periodically. Coffee Conversations, Town Halls, Quarterly Confluence, All Hands Meet, Mentoring, Branch Visits are few such initiatives that help us “Connect & Listen to our Colleagues”",
  },
  {
    title: "Developing..",
    imageUrl: Developing,
    description:
      "Improve Bottom-line, Attract Develop & Retain Talent, Drive Strategy Execution, Increase success by navigating change. These are the 4 key pillars that drive development at Thomas Cook India. Management Development Programs, Potential Development Centers, Self Awareness sessions, Customised learning interventions & a whole combination of online and classroom modules help us “Develop Future Leaders”",
  },
  {
    title: "Transforming..",
    imageUrl: Transforming,
    description:
      "Create value, unlocking employee potential, harnessing intellectual property, usage of technology & becoming highly efficient to maximise growth opportunities. At Thomas Cook, employee career movements, succession planning, organization projects help us build & Transform.",
  },
];
const designationList = [
  {
    title: "Information",
    imageUrl: Information,
  },
  {
    title: "Admin",
    imageUrl: Admin,
  },
  {
    title: "Collections",
    imageUrl: Collections,
  },
  {
    title: "Corporate",
    imageUrl: Corporate,
  },
  {
    title: "Business",
    imageUrl: Business,
  },
  {
    title: "Finance",
    imageUrl: Finance,
  },
  {
    title: "Foreign",
    imageUrl: Foreign,
  },
  {
    title: "Holidays",
    imageUrl: Holidays,
  },
  {
    title: "HumanResource",
    imageUrl: HumanResource,
  },
  {
    title: "Mice",
    imageUrl: Mice,
  },
  {
    title: "Secretarial",
    imageUrl: Secretarial,
  },
  {
    title: "Shared",
    imageUrl: Shared,
  },
];

export { connectWithList, designationList };
